import api from './request'

export function getIntegrations (query) {
  return api({
    url: '/integrations',
    method: 'get',
    params: query
  })
}
